import * as React from 'react';
import { rem } from 'polished';
import OriginalIcon from '../../Icon';
import styled from 'styled-components';
const InputIcon = (props) => React.createElement(OriginalIcon, { ...props });
export default styled(InputIcon) `
  padding: 0 ${rem(12)};
`;
